export default __webpack_public_path__ + "static/media/icon-documents.db00fe33.svg";